import React from "react";
import PropTypes from "prop-types";
import { Screen } from "../Screen";
import { Input } from "../Input";
import { Seperation } from "./Seperation";
import { Text } from "./Text";
import { useTranslation } from "react-i18next";

import "./style.scss";

const TRANSLATION_KEY = {
  HH: "HH.string",
  MM: "MM.string",
  SS: "SS.string",
  HOUR_INPUT: "HourInput.string",
  MINUTE_INPUT: "MinutesInput.string",
  SECOND_INPUT: "SecondsInput.string",
};

export function TimerDisplay(props) {
  const { t } = useTranslation();

  const [hours, setHours] = React.useState();
  const [minutes, setMinutes] = React.useState();
  const [seconds, setSeconds] = React.useState();

  React.useEffect(() => {
    setHours(props.timeData.getHours());
    setMinutes(props.timeData.getMinutes());
    setSeconds(props.timeData.getSeconds());
  }, [props.timeData]);

  const setTimerSeconds = (seconds) => {
    const time = new Date(props.timeData.getTime());
    time.setSeconds(seconds);
    props.setTimer(time);
  };
  const setTimerMinutes = (minutes) => {
    const time = new Date(props.timeData.getTime());
    time.setMinutes(minutes);
    props.setTimer(time);
  };
  const setTimerHours = (hours) => {
    const time = new Date(props.timeData.getTime());
    time.setHours(hours);
    props.setTimer(time);
  };

  return (
    <Screen className="mc_settings_timerDisplay">
      <div className="mc_settings_timerDisplay_inputBlock">
        <Text className="hhText"> {t(TRANSLATION_KEY.HH)} </Text>
        <Input
          className="mc_settings_timerDisplay_inputBlock_input  hh_input"
          value={hours}
          setValue={setTimerHours}
          ariaLabel={t(TRANSLATION_KEY.HOUR_INPUT, { hours: hours })}
        />
        <Seperation className="hh_mm_seperator" />
        <Text className="mmText"> {t(TRANSLATION_KEY.MM)}</Text>
        <Input
          className="mc_settings_timerDisplay_inputBlock_input  mm_input"
          value={minutes}
          setValue={setTimerMinutes}
          ariaLabel={t(TRANSLATION_KEY.MINUTE_INPUT, { minutes: minutes })}
        />
        <Seperation className="mm_ss_seperator" />
        <Text className="ssText"> {t(TRANSLATION_KEY.SS)}</Text>
        <Input
          className="mc_settings_timerDisplay_inputBlock_input  ss_input"
          value={seconds}
          setValue={setTimerSeconds}
          ariaLabel={t(TRANSLATION_KEY.SECOND_INPUT, { seconds: seconds })}
        />
      </div>
    </Screen>
  );
}

Screen.propTypes = {
  /**
   * date time data for timer
   */
  timeData: PropTypes.instanceOf(Date),
  /**
   * callback function to set time value
   */
  setTimer: PropTypes.func,
};

Screen.defaultProps = {
  className: "",
};
